import { Radio, Tooltip } from 'antd'
import classNames from 'classnames'
import { MyForm } from '~/components/ui/MyForm'
import styles from '../AiForm.module.css'
import { QuestionCircleOutlined } from '@ant-design/icons'
import {
  DEFAULT_OPTIONS,
  modelCodeAtom,
  optionsAtom,
  paintTimesAtom,
  selectModelAtom,
} from './atom'
import { useAtom } from 'jotai'

export const ModelSelectComp = () => {
  const [selectModel, setSelectModel] = useAtom(selectModelAtom)
  const [, setModelCode] = useAtom(modelCodeAtom)
  const [, setPaintTimes] = useAtom(paintTimesAtom)
  const [options] = useAtom(optionsAtom)

  return (
    <MyForm.Item
      label={
        <span>
          * 模型选择{' '}
          <Tooltip
            placement="topLeft"
            arrowPointAtCenter
            title="通用模型的生成速度很快，逻辑性强；场景模型的生成时间较长，更擅长恢弘的色彩想象"
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </span>
      }
      className={classNames(styles.borderLessFormItem, '!mb-8')}
    >
      <Radio.Group
        className={styles.customRadioGroup}
        onChange={e => {
          setPaintTimes(1)
          setSelectModel(e.target.value)
          // 备注：重置modelCode是为了不想风格模型切换到二次元/通用模型的时候，选中风格模型的原始模型
          setModelCode(DEFAULT_OPTIONS.MODEL_CODE)
        }}
        value={selectModel}
      >
        {options?.modelSupportOptions.map(item => {
          const checked = selectModel === item.model
          return (
            <Radio
              value={item?.model}
              key={item?.model}
              className={classNames(styles.customRadio, '!mb-0')}
            >
              <div
                className={classNames(
                  'flex relative items-center justify-between cursor-pointer py-3 px-4 h-[104px] border-2 border-solid border-neutral-200 rounded-xl flex-1 bg-neutral-200',
                  styles.radioBtn,
                  styles.modelBg
                )}
              >
                {item.tag && (
                  <div className="absolute top-1 right-1 p-1 rounded-full text-center bg-error text-neutral-900 text-[12px] leading-none scale-[0.83]">
                    {item.tag}
                  </div>
                )}
                <div
                  className={classNames('flex-1 transition-all', {
                    'text-center': !checked,
                  })}
                >
                  <div className="text-neutral-800 font-semibold">
                    {item?.name}
                  </div>
                  <div className="text-neutral-500 text-xs">{item?.desc}</div>
                </div>
                {checked && (
                  <div className="w-20 h-20">
                    <img src={item.url || ''} alt={item.name!} />
                  </div>
                )}
              </div>
            </Radio>
          )
        })}
      </Radio.Group>
    </MyForm.Item>
  )
}
